import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('Information', null, { withChildren: true });
